export default __webpack_public_path__ + "static/media/icon-fontawesome.9ed5974c.png";